import { DarkTheme, DefaultTheme, ThemeProvider } from '@react-navigation/native';
import { useFonts } from 'expo-font';
import { Slot, Stack } from 'expo-router';
import * as SplashScreen from 'expo-splash-screen';
import { useEffect, useState } from 'react';
import { View } from 'react-native';
import { usePersistSecureBoundStore } from '@/services/zustand/Store';
import { useColorScheme } from '@/hooks/useColorScheme';
import { useRouter } from 'expo-router';
import { isLoggedIn } from '@/services/typo3api/auth.web';
import { removeAllEventListeners, addEventListener } from '@/services/EventService';

SplashScreen.preventAutoHideAsync();

export default function RootLayout() {
  const colorScheme = useColorScheme();
  const router = useRouter();
  const [loggedIn, setLoggedIn] = useState<boolean | null>(null);
  const [stackName, setStackName] = useState<string>('');

  const [fontsLoaded] = useFonts({
    SpaceMono: require('../assets/fonts/SpaceMono-Regular.ttf'),
  });

  useEffect(() => {
    if (fontsLoaded) {
      SplashScreen.hideAsync();
    }
  }, [fontsLoaded]);

  const checkLogin = async () => {
    return new Promise(async (resolve, reject) => {
      const status = await isLoggedIn();
      resolve(status);
    });
    
  };
 
  const rerouteLogin = async () => {
    await checkLogin();
    setStackName("(tabs)");
    router.navigate("/(tabs)");    
  };  
  const rerouteLogout = async () => {
    await checkLogin();
    setStackName("(auth)");
    router.navigate("/(auth)");
  };

  useEffect(() => {
    const init = async () => {
      removeAllEventListeners('LoginEvent');
      removeAllEventListeners('LogoutEvent');
      addEventListener('LoginEvent', rerouteLogin);
      addEventListener('LogoutEvent', rerouteLogout);

      const isLoggedIn = await checkLogin();

      

      if(isLoggedIn) {
        setLoggedIn(true);
        setStackName("(tabs)");
        router.navigate("/(tabs)"); 
      }
      else {
        setLoggedIn(false);
        setStackName("(auth)");
        router.navigate("/(auth)");
      }
    };
    init();
    return () => {
      removeAllEventListeners('LoginEvent');
      removeAllEventListeners('LogoutEvent');
    };
  }, [stackName]);

  if (!fontsLoaded || loggedIn === null || stackName === '') {
    return (
      <Slot />
    );
  }

  if(stackName === '(tabs)') {
    <ThemeProvider value={colorScheme === 'dark' ? DarkTheme : DefaultTheme}>
      <View style={{ flex: 1 }}>
        {stackName === '(tabs)' && (
          <Stack>
            <Stack.Screen name="(tabs)" options={{ headerShown: false }} />
            <Stack.Screen name="Modal" options={{ headerShown: true, presentation: 'modal' }} />
            <Stack.Screen name="Datepicker" options={{ headerShown: true, presentation: 'modal' }} />
            <Stack.Screen name="Editionpicker" options={{ headerShown: true, presentation: 'modal' }} />
          </Stack>
        )}
      </View>
    </ThemeProvider>
  }

  if(stackName === '(auth)') {
    <ThemeProvider value={colorScheme === 'dark' ? DarkTheme : DefaultTheme}>
      <View style={{ flex: 1 }}>
        <Stack>
          <Stack.Screen name="(auth)" options={{ headerShown: false }} />
          <Stack.Screen name="Datepicker" options={{ headerShown: true, presentation: 'modal' }} />
          <Stack.Screen name="Editionpicker" options={{ headerShown: true, presentation: 'modal' }} />
        </Stack>
      </View>
    </ThemeProvider>
  }



  return (
    <ThemeProvider value={colorScheme === 'dark' ? DarkTheme : DefaultTheme}>
      <View style={{ flex: 1 }}>
        {stackName === '(tabs)' && (
          <Stack>
            <Stack.Screen name="(tabs)" options={{ headerShown: false }} />
            <Stack.Screen name="Modal" options={{ headerShown: true, presentation: 'modal' }} />
            <Stack.Screen name="Datepicker" options={{ headerShown: true, presentation: 'modal' }} />
            <Stack.Screen name="Editionpicker" options={{ headerShown: true, presentation: 'modal' }} />
          </Stack>
        )}
        {stackName === '(auth)' && (
          <Stack>
            <Stack.Screen name="(auth)" options={{ headerShown: false }} />
            <Stack.Screen name="Datepicker" options={{ headerShown: true, presentation: 'modal' }} />
            <Stack.Screen name="Editionpicker" options={{ headerShown: true, presentation: 'modal' }} />
          </Stack>
        )}
      </View>
    </ThemeProvider>
  );
}
